import React, { useState, useEffect } from 'react';
import { Button,Grid,  Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Checkbox, TextField } from '@mui/material';
import { Link } from 'react-router-dom'; 
import { useForm } from "react-hook-form";
import {apiDocument} from '../../services/api/documents/Document';
import { apiProvider } from '../../services/api/utilities/Provider';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {authVerify} from "../../services/api/utilities/AuthVerify";
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useTranslation } from "react-i18next";
import { useNavigate,useLocation,useSearchParams } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import SignatureCanvas from 'react-signature-canvas';
import {isMobile,useMobileOrientation } from 'react-device-detect';

const IndexComponent = (props) => {
    const { register } = useForm();
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [isSignEnabled, setIsSignEnabled] = useState(false);
    const [role, setRole] = useState('');
    const [sortIndex, setSortIndex] = useState(-1);
    const [sortName, setSortName] = useState('');
    const [hover, setHover] = useState(-1);
    const [sortOrder, setSortOrder] = useState('asc');
    const [length, setLength] = useState(0);
    const [openSign, setOpenSign] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const [openInfo2, setOpenInfo2] = useState(false);
    const [isClickSign, setIsClickSign] = useState(false);
    const [sigCanvas,setSigCanvas] = useState({});
    const [sigCanvasMobile,setSigCanvasMobile] = useState({});
    const [sigCanvasMobileLandscape,setSigCanvasMobileLandscape] = useState({});
    const [selectedIds, setSelectedIds] = useState([]);
    const [queryParams, setQueryParams] = useState({ start: 0, end: 10, search: '' });
    const [searchParams] = useSearchParams();
    const { t, i18n, ready } = useTranslation();
    const navigate = useNavigate();
    const {isLandscape} = useMobileOrientation();

    let location = useLocation();

    useEffect(() => {
        authVerify.verifyUser();
        async function fetchData() {
            props.setIsOpenPay(false);
            await refreshItems();
        }
        setRole(localStorage.getItem('role'));
        fetchData();
    }, []);

    useEffect(() => {
        setIsSignEnabled(selectedIds.length > 0);
    }, [selectedIds]);

    const handleCheck = (id, checked) => {
        setSelectedIds((prevSelected) => {
            let nextSelected;
            if (checked) {
                if (prevSelected.includes(id)) {
                    nextSelected = prevSelected;
                } else {
                    nextSelected = [...prevSelected, id];
                }
            } else {
                nextSelected = prevSelected.filter((selectedId) => selectedId !== id);
            }
            return nextSelected;
        });

        setItems((prevItems) =>
            prevItems.map((item) =>
                item.id === id ? { ...item, isChecked: checked } : item
            )
        );
    };

    const handleRowClick = (row) => {
        navigate(`/sign?id=${row.id}`); // Template literal for cleaner string concatenation
    };

    const sort = async (name)=>{
        setPage(0);
        queryParams.order = name;
        setQueryParams({ start: 0, end: 10, search: queryParams.search, order: sortName });
        await refreshItems(queryParams);
    }

    const handleClear = () => {
        setIsClickSign(false);
        if(isMobile && isLandscape)
            sigCanvasMobileLandscape.clear();
        else if(isMobile)
            sigCanvasMobile.clear();
        else
            sigCanvas.clear();
    };

    const setSort = async (index) => {
        let tempSortName = '';
        if(index===sortIndex && sortOrder!=='desc')
        {
            setSortOrder('desc');
            if(index===0)
            {
                tempSortName = '-sendDate';
            }
            if(index===1)
            {
                tempSortName ='-name';
            }
            if(index===2)
            {
                tempSortName ='-sendUserProfileName';
            }
        }
        else
        {
            setSortOrder('asc');
            if(index===0)
            {
                tempSortName = 'sendDate';
            }
            if(index===1)
            {
                tempSortName ='name';
            }
            if(index===2)
            {
                tempSortName ='sendUserProfileName';
            }
        }
        setSortName(tempSortName);
        setSortIndex(index);
        let query = { start: 0, end: 10, search: queryParams.query, order: tempSortName };
        setQueryParams(query);
        await refreshItems(query);
    }

    const refreshItems = async (tempQuery=null)=>{
        let data = null;
        setIsLoading(true);
        if(tempQuery!==null)
            data = await apiDocument.search(tempQuery);
        else
            data = await apiDocument.search(queryParams);

        if (location.search.indexOf('id=') >= 0 && data) {
            let id = searchParams.get('id');
            const signer = data.items.filter(item => item.id == id);
            if(signer.length>0 && signer[0].status===3)
                setOpenInfo(true);
            if(signer.length>0 && signer[0].status===2)
                setOpenInfo2(true);
        }
        
        if(data.code==='ERR_NETWORK')
        {
            localStorage.setItem('token', '');
            localStorage.setItem('fullName', '');
            localStorage.setItem('role', '');
            localStorage.setItem('email', '');
            localStorage.setItem('avatar', '');
            window.location.href = "/";
        }

        if (data != null) {
            const selectedSet = new Set(selectedIds);
            const updatedItems = data.items.map((item) => ({
                ...item,
                isChecked: selectedSet.has(item.id),
            }));
            setItems(updatedItems);
            setLength(data.length);
            setIsLoading(false);
        }
    }
    
    const search = async(query) => {        
        setPage(0);
        queryParams.search = query;
        setQueryParams({ start: 0, end: 10, search: query, order: sortName });
        await refreshItems(queryParams);
    }

    const handleChangePage = async (event, newPage) => {
        setPage(newPage);
        let query = {start:(newPage*10), end: ((newPage+1)*10), search:'', order: sortName };
        setQueryParams(query);
        await refreshItems(query);
    };

    const pageLeft = async () => {
        let newPage=0;
        if(page>1)
            newPage=page-1;
        setPage(newPage);
        let query = {start:(newPage*10), end: ((newPage+1)*10), search:'', order: sortName };
        setQueryParams(query);
        await refreshItems(query);
    };

    const pageRight = async () => {
        let newPage = 1;
        if(page<=parseInt(length/10))
            newPage=page+1;
        setPage(newPage);
        let query = {start:(newPage*10), end: ((newPage+1)*10), search:'', order: sortName };
        setQueryParams(query);
        await refreshItems(query);
    };

    const downloadFile = async (id) => {
        apiDocument.openUrl(`/api/document/file/${id}`);
    };

    const downloadFiles = async () => {
        for (const id of selectedIds) {
            await downloadFile(id);
        }
    };

    const clickDocument = async(id) => {
        window.location.href = "/sign?id="+id;
    }

    const handleClose = () => {
        
        setOpenSign(false);
        
    };

    const sign = async () => {
        if (isLoading || selectedIds.length === 0) {
            return;
        }

        const canvasRef = isMobile
            ? (isLandscape ? sigCanvasMobileLandscape : sigCanvasMobile)
            : sigCanvas;

        if (!canvasRef || typeof canvasRef.toDataURL !== 'function') {
            return;
        }

        setIsLoading(true);

        try {
            const signatureImage = canvasRef.toDataURL();
            for (const id of selectedIds) {
                await apiDocument.sign({ id, signature: signatureImage });
            }
            await refreshItems();
            setSelectedIds([]);
            setIsClickSign(false);
            setOpenSign(false);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="main-body">
            {(role==='2' || role==='3') &&
                <Grid container>
                    <Grid item xs={6} className='only-mobile'>
                        <Link className="first-tab" to="/create">{t("index_text1")}</Link>
                    </Grid>
                    <Grid item xs={6} className='only-mobile'>
                        <Link className="second-tab">{t("index_text2")}</Link>
                    </Grid>
                </Grid>
            }
            {(role!=='2' && role!=='3') &&
                <Grid container>
                    <Grid item xs={12} className='only-mobile'>
                        <Link to="/index" className="first-tab">{t("index_text3")}</Link>
                    </Grid>
                </Grid>
            }
            <div className="not-mobile" style={{width:'100%'}}>
                <div>
                    <Grid container>
                        <Grid item xs>
                            <Button className="button signer button-little-small button-all-sign" onClick={()=>{setOpenSign(true);}} disabled={!isSignEnabled}><i className="edit-sign-icon"></i>Podpisz wybrane dokumenty</Button>
                        </Grid>
                        <Grid item style={{width: "300px", marginTop:10}}>
                            {selectedIds.length > 0 && <p>{t("index_text15", { count: selectedIds.length })}</p>}
                        </Grid>
                        <Grid item style={{width: "300px"}} className="right-element search-field">
                            <i className="search"></i>
                            <TextField autoComplete='off' placeholder={t("index_text4")} className='search-input' {...register("search",{onChange: (e) => search(e.target.value)})}/>
                        </Grid>
                    </Grid>
                    {isLoading
                    && <Grid container className="padding-body">
                            <div className="loader-blue"></div>
                        </Grid>
                    }
                    {!isLoading && 
                    <Grid container className="padding-body">
                        <Grid item xs={12}>
                            <TableContainer className="document-list">
                                <Table aria-labelledby="tableTitle" aria-label="enhanced table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                
                                            </TableCell>
                                            <TableCell>
                                                <i className='arrow-list'></i>
                                            </TableCell>
                                            <TableCell align="left" className='sortColumn' onClick={()=>setSort(0)} onMouseOver={()=>setHover(0)} onMouseOut={()=>setHover(-1)}><span>{t("index_text5")}</span>{sortIndex===0 && sortOrder==='asc' && <span><ExpandMoreIcon/></span>}{sortIndex===0 && sortOrder==='desc' && <span><ExpandLessIcon/></span>}{hover===0 && sortIndex!==0 && <span><ExpandMoreIcon className="gray-icon"/></span>}</TableCell>
                                            <TableCell align="left" className='sortColumn' onClick={()=>setSort(1)} onMouseOver={()=>setHover(1)} onMouseOut={()=>setHover(-1)}><span>{t("index_text6")}</span>{sortIndex===1 && sortOrder==='asc' && <span><ExpandMoreIcon/></span>}{sortIndex===1 && sortOrder==='desc' && <span><ExpandLessIcon/></span>}{hover===1 && sortIndex!==1 && <span><ExpandMoreIcon className="gray-icon"/></span>}</TableCell>
                                            <TableCell align="left" className='sortColumn' onClick={()=>setSort(2)} onMouseOver={()=>setHover(2)} onMouseOut={()=>setHover(-1)}><span>{t("index_text7")}</span>{sortIndex===2 && sortOrder==='asc' && <span><ExpandMoreIcon/></span>}{sortIndex===2 && sortOrder==='desc' && <span><ExpandLessIcon/></span>}{hover===2 && sortIndex!==2 && <span><ExpandMoreIcon className="gray-icon"/></span>}</TableCell>
                                            <TableCell align="left" className='sortColumn' onClick={()=>setSort(3)} onMouseOver={()=>setHover(3)} onMouseOut={()=>setHover(-1)}><span>{t("index_text8")}</span>{sortIndex===3 && sortOrder==='asc' && <span><ExpandMoreIcon/></span>}{sortIndex===3 && sortOrder==='desc' && <span><ExpandLessIcon/></span>}{hover===3 && sortIndex!==3 && <span><ExpandMoreIcon className="gray-icon"/></span>}</TableCell>
                                            <TableCell align="left" className='sortColumn'><span>{t("index_text9")}</span></TableCell>
                                            <TableCell align="left" className='sortColumn'><span>{t("index_text9b")}</span></TableCell>
                                            <TableCell align="left">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className='edit'></i>&nbsp;<i className='document'></i></TableCell>
                                            <TableCell align="left"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {items.map((row, index) => {
                                        return(
                                            <TableRow key={index}>
                                                <TableCell>
                                                    {(row.isToSigned>0 && !row.isMySigned) && !row.isAllPage && !row.isFields && <input type="checkbox" checked={row.isChecked} onChange={(e) => {handleCheck(row.id,e.target.checked);}}></input>}
                                                </TableCell>
                                                <TableCell onClick={()=>handleRowClick(row)}>
                                                    {row.documentType===1 && <i className='arrow-up'></i>}
                                                    {row.documentType===2 && <i className='arrow-down'></i>}
                                                </TableCell>
                                                <TableCell align="left" onClick={()=>handleRowClick(row)}><a>
                                                    <span>{row.sendDateName}</span></a>
                                                </TableCell>
                                                <TableCell align="left" onClick={()=>handleRowClick(row)}>{row.name}</TableCell>
                                                <TableCell align="left" onClick={()=>handleRowClick(row)}>{row.sendUserProfileName}</TableCell>
                                                <TableCell align="left" onClick={()=>handleRowClick(row)}>{row.items}</TableCell>
                                                <TableCell align="left" onClick={()=>handleRowClick(row)}>{row.itemsSigned}&nbsp;&nbsp;&nbsp;
                                                    {(row.status===0 || row.status===1) && <i className="red-dot"></i>}
                                                    {row.status===2 && <i className="yellow-dot"></i>}
                                                    {row.status===3 && <i className="green-dot"></i>}
                                                </TableCell>
                                                <TableCell align="left" onClick={()=>handleRowClick(row)}>{row.randomCode}</TableCell>
                                                <TableCell align="left" onClick={()=>handleRowClick(row)}>
                                                    {(row.isToSigned>0 && !row.isMySigned) && <Link className="button" color="primary" to={"/sign?id="+row.id}>{t("index_text10")}</Link>}
                                                    {(row.isToSigned===0 || row.isMySigned) && <Link className="button button-white" to={"/sign?id="+row.id}>{t("index_text11")}</Link>}
                                                </TableCell>
                                                <TableCell align="left" onClick={()=>handleRowClick(row)}><Button className="button button-small" onClick={()=>downloadFile(row.id)}><i className='download-white'>&nbsp;</i></Button></TableCell>
                                            </TableRow>
                                        );
                                    })}
                                    </TableBody>
                                </Table>
                                <TablePagination component="div" count={length} rowsPerPage={10} page={page} labelRowsPerPage="" onPageChange={handleChangePage}/>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    }
                </div>
            </div>
            {isLoading && 
                <Grid container className="padding-body only-mobile">
                    <div className="loader-blue"></div>
                </Grid>
            }
            {!isLoading && 
            <div className="wrapper only-mobile">
                <Grid container>
                    <Grid item className="search-field" xs={12}>
                        <i className="search"></i>
                        <TextField autoComplete='off' placeholder={t("index_text12")} className='search-input' {...register("search2",{onChange: (e) => search(e.target.value)})}/>
                    </Grid>
                </Grid>

                <Grid container>
                    {items.map((row, index) => {
                        return(
                            <Grid item className={"document-box"+" "+((!row.isToSigned || row.isMySigned) ? "no-background":"")} xs={12} key={index} onClick={()=>clickDocument(row.id)}>
                                <Grid container>
                                    <Grid item xs={1}>
                                        <Grid container>
                                            <Grid item>
                                                {row.documentType===1 && <i className='arrow-up'></i>}
                                                {row.documentType!==1 && <i className='arrow-down'></i>}
                                            </Grid>
                                            <Grid item>
                                                {row.isToSigned!==0 && !row.isMySigned && 
                                                    <i className='edit'></i>
                                                }
                                                {(row.isToSigned===0 || row.isMySigned) && 
                                                    <i className='document'></i>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <p>{(row.status===0 || row.status===1) && <i className="red-dot"></i>}
                                            {row.status===2 && <i className="yellow-dot"></i>}
                                            {row.status===3 && <i className="green-dot"></i>}&nbsp;&nbsp;{row.name}</p>
                                        <p><span>{t("index_text13")}: </span>{row.sendDateName}&nbsp; 
                                            {row.isFull && <i className='clock-row'></i>}
                                            {row.isSemi && !row.isFull && <i className='semi-clock-row'></i>}
                                            {row.isQuarter && !row.isFull && !row.isSemi && <i className='quarter-clock-row'></i>}
                                            {row.isEmpty && !row.isQuarter && !row.isFull && !row.isSemi && <i className='empty-clock-row'></i>}
                                            {!row.isEmpty && !row.isQuarter && !row.isFull && !row.isSemi && <i className='empty-clock-row'></i>}</p>
                                        <p><span>{t("index_text14")}: </span>{row.sendUserProfileName}</p>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <IconButton
                                            size="large"
                                            edge="start"
                                            color="inherit"
                                            aria-label="menu"
                                            sx={{ mr: 2, mt:0.5 }}>
                                            <ArrowForwardIosIcon/>
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
                <Grid container>
                    <Grid item xs={10}>
                    </Grid>
                    <Grid item xs={1} onClick={()=>pageLeft()}>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2, mt:0.5 }}>
                            <ArrowBackIosIcon/>
                        </IconButton>
                    </Grid>
                    <Grid item xs={1} onClick={()=>pageRight()}>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2, mt:0.5 }}>
                            <ArrowForwardIosIcon/>
                        </IconButton>
                    </Grid>
                </Grid>
            </div>
            }

            <Dialog open={openInfo} onClose={()=>setOpenInfo(false)} style={{padding:"10px"}}>
                <DialogContent>
                    <DialogTitle>Tw�j podpis zosta� z�o�ony!</DialogTitle>
                    <DialogContentText>
                        Dokument zosta� podpisany przez wszystkich odbiorc�w i wys�any na Tw�j adres e-mail. Znajdziesz go tak�e na li�cie dokument�w w SignSafe.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2}>
                        <Grid item xs>
                            <Button className="button full-width" onClick={()=>setOpenInfo(false)}>
                                <span>OK</span>
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <Dialog open={openInfo2} onClose={()=>setOpenInfo2(false)} style={{padding:"10px"}}>
                <DialogContent>
                    <DialogTitle>Tw�j podpis zosta� z�o�ony!</DialogTitle>
                    <DialogContentText>
                        Dokument czeka jeszcze na podpisy innych odbiorc�w. Gdy wszyscy go podpisz�, prze�lemy Ci dokument na Tw�j adres e-mail. Znajdziesz go tak�e na li�cie dokument�w w SignSafe.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2}>
                        <Grid item xs>
                            <Button className="button full-width" onClick={()=>setOpenInfo2(false)}>
                                <span>OK</span>
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <Dialog open={openSign} onClose={handleClose} style={{padding:"10px"}}>
                <div className="dialog-sign">
                    <DialogTitle>{t("sign_text32")}</DialogTitle>
                    <DialogContent>
                        {!isMobile &&
                        <div>
                            <SignatureCanvas canvasProps={{width: 500, height: 300, className: 'sigCanvas'}} ref={(ref) => { setSigCanvas(ref) }} onBegin={()=>setIsClickSign(true)}/>
                        </div>
                        }
                        {isMobile && !isLandscape &&
                        <div>
                            <SignatureCanvas canvasProps={{width: window.innerWidth>700 ? (window.innerWidth-250):250, height:  250, className: 'sigCanvas'}} ref={(ref) => { setSigCanvasMobile(ref) }} onBegin={()=>setIsClickSign(true)}/>
                        </div>
                        }
                        {isMobile && isLandscape &&
                        <div>
                            <SignatureCanvas canvasProps={{width: 400, height: 200, className: 'sigCanvas'}} ref={(ref) => { setSigCanvasMobileLandscape(ref) }} onBegin={()=>setIsClickSign(true)}/>
                        </div>
                        }
                    </DialogContent>
                    <DialogActions >
                        <Grid container spacing={2} className="right-side action-margin">
                            <a className="button button-cancel" fullWidth onClick={()=>handleClose()}>{t("sign_text33")}</a>&nbsp;&nbsp;
                            <a className="button button-cancel" fullWidth onClick={()=>handleClear()}>{t("sign_text34")}</a>&nbsp;&nbsp;
                            <Button className="button" onClick={()=>sign()} disabled={!isClickSign}>
                                {isLoading && 
                                    <span className="loader"></span>
                                }
                                {!isLoading && 
                                    <span>{t("sign_text35")}</span>
                                }
                            </Button>
                        </Grid>
                    </DialogActions>
                </div>
            </Dialog>
        </div>
    );
}

export default IndexComponent;

